import React from 'react'
import ContactSection from '../components/Contact'
import Footer from '../components/Footer'
import NavHeader from '../components/NavHeader'

const HelpCenterPage: React.FC = () => {
  return (
    <div className='min-h-screen bg-transparent flex flex-col'>
      {/* Navigation Header */}
      <NavHeader activeTab='help-center' />

      {/* Get in Touch */}
      <div className='flex-1'>
        <ContactSection />
      </div>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default HelpCenterPage
